import { SimpleGrid } from "@chakra-ui/react";
import Image from "next/image";
import { useIntl } from "react-intl";
import { PARTNERS } from "../../../../constants/Partners";

export function Partners() {
  const intl = useIntl();

  return (
    <SimpleGrid columns={5} spacing="1rem" justifyItems="center">
      {PARTNERS.map((partner, index) => (
        <Image
          key={index}
          width={105}
          height={80}
          src={partner.src}
          alt={intl.formatMessage(partner.label)}
          loading="lazy"
        />
      ))}
    </SimpleGrid>
  );
}
